export default {
    cancel: 'Cancel',
    fingerModalClose: 'Close modal',
    modalTitle: 'Important Information',
    modalContent:
    'When you click "Proceed," a new tab or window will be opened to a third-party website and this tab will remain open.  Don\'t forget to return to the Legal Tune Up tool to follow up on additional actions you might be able to take with your legal records.',
    proceed: 'Proceed',
};
